import { GET_CATEGARY, GET_CATEGARY_BY_ID, GET_CATEGARY_PRODUCT } from "../constants/index";

export const category = (
  state = { categorylist: [], categorybyid: {} },
  action,
) => {
  switch (action.type) {
    case GET_CATEGARY:
      return { ...state, categorylist: action.categorylist };
      case GET_CATEGARY_PRODUCT:
      return { ...state, categoryProductlist: action.categoryProductlist };
    case GET_CATEGARY_BY_ID:
      return { ...state, categorybyid: action.categorybyid };
    default:
      return state;
  }
};
